export type ShareResponse = {
  shareId: string;
  virtualId: string;
  startTimestamp: number;
  endTimestamp: number;
  trackingUrl: string;
  smsRecipients: string[];
  location: {
    latitude: {
      serviceName: string;
      serviceType: string;
      time: number;
      serviceValue: number;
    };
    longitude: {
      serviceName: string;
      serviceType: string;
      time: number;
      serviceValue: number;
    };
  };
};

export type Coordinate = {
  latitude: number;
  longitude: number;
  timestamp: string;
};

// Error types for different scenarios
export enum ErrorType {
  EXPIRED = "EXPIRED",
  NOT_FOUND = "NOT_FOUND",
  FUTURE = "FUTURE",
  NETWORK = "NETWORK",
  UNKNOWN = "UNKNOWN",
}
